/**
 * API Service for Assets (Territories, Entities, Sites)
 * Handles hierarchical selection in Step 1 of the wizard
 */

import apiClient from './index';

/**
 * Get list of all territories
 * @returns {Promise<Array>} List of territories
 */
export async function getTerritories() {
  try {
    const response = await apiClient.get('/territories');
    return response.data;
  } catch (error) {
    console.error('Error fetching territories:', error);
    throw error;
  }
}

/**
 * Get entities for a specific territory
 * @param {number} territoryId - Territory ID
 * @returns {Promise<Array>} List of entities
 */
export async function getEntitiesByTerritory(territoryId) {
  try {
    const response = await apiClient.get('/entities', {
      params: { territory_id: territoryId },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching entities:', error);
    throw error;
  }
}

/**
 * Get assets (heating plants/sites) for a specific entity
 * @param {number} entityId - Entity ID
 * @param {number} territoryId - Territory ID (optional, for filtering by department)
 * @returns {Promise<Array>} List of assets
 */
export async function getAssetsByEntity(entityId, territoryId = null) {
  try {
    const params = territoryId ? { territory_id: territoryId } : {};
    const response = await apiClient.get(`/entities/${entityId}/sites`, { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching assets:', error);
    throw error;
  }
}

/**
 * Get details for a specific asset including its configuration
 * @param {string} assetId - Asset ID (UUID)
 * @returns {Promise<Object>} Asset details with configuration
 */
export async function getAssetDetails(assetId) {
  try {
    const response = await apiClient.get(`/assets/${assetId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching asset details:', error);
    throw error;
  }
}
